import { createSelector } from 'reselect';
import { matchPath } from 'react-router';
import { mapValues } from 'lodash';
import { PLAYER_ROUTES } from 'constants/player-routes';

const getPlayerSelector = (state) => state.player;

export const getPlayerTypeSelector = createSelector(
  getPlayerSelector,
  (player) => player.playerType,
);

const getQueryParamsSelector = createSelector(getPlayerSelector, (player) => player.queryParams);

export const getIsContinueWatchingSelector = createSelector(
  getPlayerSelector,
  (player) => player.startFrom > 0,
);

export const getVideoIdSelector = createSelector(
  getQueryParamsSelector,
  (queryParams) => queryParams.videoId,
);

export const getChannelIdSelector = createSelector(
  getQueryParamsSelector,
  (queryParams) => queryParams.channelId,
);

export const getProgramStartTimeSelector = createSelector(
  getQueryParamsSelector,
  (queryParams) => queryParams.startTime,
);

export const getSeriesIdSelector = createSelector(
  getQueryParamsSelector,
  (queryParams) => queryParams.seriesId,
);

export const getEpisodeIdSelector = createSelector(
  getQueryParamsSelector,
  (queryParams) => queryParams.episodeId,
);

export const getIsStoppedStatusSelector = createSelector(
  getPlayerSelector,
  (player) => player.isStopped,
);

export const getCurrentTimeSelector = createSelector(
  getPlayerSelector,
  (player) => player.currentTime,
);

export const getErrorSelector = createSelector(getPlayerSelector, (player) => player.error);

export const getIsPlayedDataLoaded = createSelector(
  getPlayerSelector,
  (player) => player.isPlayedDataLoaded,
);

// Default props.match.params works with a little delay which causes a lot of bugs
// More convenient way to have match params - is to get the from location.pathname, which updates with no delay
export const getQueryParamsFromPropsSelector = createSelector(
  (_state, props) => props.history.location.pathname,
  (pathname) => {
    // Some values expected to be a number
    const keysToNumber = ['videoId', 'seriesId', 'episodeId', 'channelId'];

    const query = PLAYER_ROUTES.reduce((r, path) => {
      const match = matchPath(pathname, { path });

      Object.assign(r, match?.params);

      return r;
    }, {});

    const modified = mapValues(query, (val, key) => {
      if (keysToNumber.includes(key)) return parseInt(query[key], 10) || null;
      return val;
    });

    return modified;
  },
);
